import '../Table.scss';
import dayjs from 'dayjs';
import chevronTable from '../../../assets/icons/chevronTable.svg';
import { USDTableType } from '../../../types';
import TransactionDetailsAlt from '../../NewSideSheet/TransactionDetailsAlt/TransactionDetailsAlt';
import { useState } from 'react';
import ModalExecuteAction from '../../Modals/ModalExecuteAction';
import useUSDRequest from '../../../hooks/useUSDRequest';
import ModalBase from '../../Modals';
import { Alert } from '@piggytechng/component-library';

const USDRequestTable = ({ tableData, withheld, refetch }: USDTableType) => {
  const [show, setShow] = useState(false);
  const [showExecutionModal, setShowExecutionModal] = useState(false);
  const [rejectionModal, setRejectionModal] = useState(false);

  const [actionType, setActionType] = useState<string | null>(null);

  const [selectedData, setSelectedData] = useState<any>(null);
  const [reason, setReason] = useState<string>('');

  const { isLoading, releaseOrRejectUSDRequest } = useUSDRequest('held');

  const selectData = (data: any) => {
    setSelectedData(data);
    setShow(true);
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const runAction = (key: string, _payload?: any) => {
    setActionType(key);
    setReason('');
    if (key === 'reject-usd-request') {
      setRejectionModal(true);
      return;
    }
    setShowExecutionModal(true);
  };

  const handleSubmit = () => {
    releaseOrRejectUSDRequest(actionType as any, selectedData.id, reason || undefined, () => {
      setShowExecutionModal(false);
      setRejectionModal(false);
      refetch?.();
    });
  };

  return (
    <>
      <div className={`table-container general-table general-table--usd-table`}>
        <table className="table">
          <thead className="table_head">
            <tr>
              <th className="user-id">User Id</th>
              {withheld && <th className="user-id">Amount</th>}
              <th className="name">User Name</th>
              <th className="email">Email Address</th>
              <th className="date">Submission Date</th>
              <th className="status">{withheld ? 'Status' : 'KYC Status'}</th>
              <th className="side-chevron"></th>
            </tr>
          </thead>
          <tbody className="table-body">
            {tableData &&
              tableData.map((val: any, index: any) => {
                return (
                  <tr
                    key={index}
                    id={val.userId}
                    className="table-row"
                    onClick={() => {
                      selectData(val);
                    }}
                  >
                    <td className="user-id">{val.user_id}</td>
                    {withheld && <td className="user-id">${val.amount}</td>}
                    <td className="name">{val.user_full_name ?? val.user_name}</td>
                    <td className="email">{val.user_email}</td>
                    <td className="date">{dayjs(new Date(val.created_at)).format('D MMM YYYY, h:mm A')}</td>
                    <td
                      className={`status status--body flex--2 processing`}
                      style={{ display: 'block', textAlign: 'center' }}
                    >
                      <span>&#8226;</span>
                      Withheld
                    </td>
                    <td className="side-chevron">
                      <img src={chevronTable} />
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>

      <TransactionDetailsAlt
        show={show}
        id={''}
        which="heldusdrequest"
        isDollar={true}
        data={selectedData}
        runAction={runAction}
        onClose={() => {
          setShow(false);
        }}
      />

      <ModalBase modalIsOpen={rejectionModal} setIsOpen={setRejectionModal}>
        <div className={`modal-processor`}>
          <div className="modal-processor__header">
            <h2>Reject USD Request</h2>
            <button onClick={() => setRejectionModal(false)}>&times;</button>
          </div>
          <div className="modal-processor__body">
            <div className="flex--4 usd-details-modal-comments">
              <label>Reason</label>
              <textarea
                name="reason"
                placeholder="Enter reason for rejection here"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              />
            </div>

            <div className="modal-processor__actions">
              <button
                onClick={() => {
                  if (!reason) {
                    Alert.error('Please enter a reason');
                    return;
                  }
                  setShowExecutionModal(true);
                  setRejectionModal(false);
                }}
              >
                Reject
              </button>
            </div>
          </div>
        </div>
      </ModalBase>

      <ModalExecuteAction
        modalIsOpen={showExecutionModal}
        isLoading={isLoading}
        setIsOpen={setShowExecutionModal}
        text={actionType === 'release-usd-request' ? 'release this USD request?' : 'reject this USD request?'}
        action={() => handleSubmit()}
        actionColor="#1734CA"
        buttonText={actionType === 'release-usd-request' ? 'Release' : 'Reject'}
      />
    </>
  );
};

export default USDRequestTable;
